import type { FC } from 'react'

import { Td } from '@skytech/ui/Table/Td'

import Highlight from '@/components/Highlight'
import { useFormattedNumberWithCurrency } from '@/hooks/use-formatted-number-with-currency'
import { useLocalDate } from '@/hooks/use-local-date'
import type { Invoice } from '@/modules/admin/resources'

export const InvoicesListItem: FC<Invoice & { searchFilter: string }> = ({
  vendor,
  invoiceNo,
  date,
  dueDate,
  invoiceAmount,
  searchFilter,
}) => {
  const { formatDate } = useLocalDate()
  const { formatNumber } = useFormattedNumberWithCurrency()

  return (
    <tr tabIndex={0}>
      <Td>
        <Highlight pattern={searchFilter} text={vendor?.name} />
      </Td>
      <Td>
        <Highlight pattern={searchFilter} text={invoiceNo} />
      </Td>
      <Td className="hidden sm:table-cell">
        <Highlight pattern={searchFilter} text={formatDate({ date })} />
      </Td>
      <Td className="hidden sm:table-cell">
        <Highlight pattern={searchFilter} text={formatDate({ date: dueDate })} />
      </Td>
      <Td className="hidden pr-6 text-right sm:table-cell">
        <Highlight
          pattern={searchFilter}
          text={formatNumber({ amount: Number(invoiceAmount), precision: 2 })}
        />
      </Td>
    </tr>
  )
}
